import { render, staticRenderFns } from "./LoaderPDF.vue?vue&type=template&id=1b6b50da&scoped=true&"
var script = {}
import style0 from "./LoaderPDF.vue?vue&type=style&index=0&id=1b6b50da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b50da",
  null
  
)

export default component.exports